import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  height: 95%;
  width: ${(props) => (props.isInstructor ? "100%" : "100%")};
  box-sizing: border-box;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  justify-content: space-between;
  /* ${STYLES.borderShadow}; */
  border-radius: 8px;
  margin-top: -30px;
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const BottomDiv = styled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: ${Colors.lightGrayColor2};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  padding: 0px 10px;
  /* margin-top: auto; Push BottomDiv to the bottom */
`;

export const MessageInput = styled.textarea`
  background-color: ${Colors.darkWhite};
  border: none;
  width: 92%;
  min-height: 25px;
  max-height: 70px;
  border-radius: 15px;
  padding: 0px 10px;
  padding-top: 10px;
  outline: none;
  overflow: hidden;
  resize: none;
  margin: 10px;
`;
export const Icon = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: ${Colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const MessageArea = styled.div`
  width: 94%;
  height: 78%;
  align-items: center;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const ChatDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 10px;
  display: flex;
  align-items: ${(props) => (props.isRight ? "flex-end" : "flex-start")};
`;

export const Chat = styled.div`
  background-color: ${Colors.darkWhite};
  border-radius: 8px;
  max-width: 60%;
  align-items: center;
  padding: 10px;
  text-align: left;
`;
